window.__RIO_KIT_MODE = window.__RIO_KIT_MODE || 'both';
/* PDP kit + add-ons. Theme asset (winning Kit + add-ons buy box).
 * CSS in rio-pdp-kit.css. Script is deferred; boot waits for DOMContentLoaded.
 *
 * Hide State/City Multi Add. Mount Ridge-style kit swatches and add-on
 * cards above Add to cart. Kit tiles stay on the PDP and press hidden
 * complementary toggles. window.__RIO_KIT_MODE = 'both' | 'kit' | 'addons'.
 * Skips mounting on gift-card, kindness, Route, and SAM PDPs.
 * Default mode keeps Kindness + U.S. National Parks cards.
 */
(function () {
  var ROOT_ID = 'rio-pdp-kit-box';
  var ACTIVE = 'rio-pdp-kit-active';
  var READY = 'rio-pdp-kit-ready';
  var SKIP_PAGE_RE = /(gift[-_]?card|kindness|\broute\b|\bsam\b|shipping-protection|shipping-insurance)/i;
  var SKIP_ITEM_RE = /(gift[-_]?card|\broute\b|\bsam\b|shipping-protection|shipping-insurance)/i;
  var ADDON_HANDLES = ['kindness-bucket-list', 'us-national-parks-bucket-list'];
  var MAX_KIT_EXTRAS = 3;
  var MAX_ADDON_EXTRAS = 2;
  var MODE = window.__RIO_KIT_MODE === 'kit' || window.__RIO_KIT_MODE === 'addons'
    ? window.__RIO_KIT_MODE
    : 'both';
  var recCache = window.__RIO_KIT_RECS || (window.__RIO_KIT_RECS = {});
  var addonCache = window.__RIO_KIT_ADDONS || (window.__RIO_KIT_ADDONS = {});

  function productHandle() {
    var path = (location.pathname || '').toLowerCase();
    var match = path.match(/\/products\/([^/?#]+)/);
    if (match && match[1]) return decodeURIComponent(match[1]);
    try {
      var meta = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product;
      if (meta && meta.handle) return String(meta.handle);
    } catch (e) {}
    return '';
  }

  function shouldSkip() {
    var path = (location.pathname || '').toLowerCase();
    if (!/^\/products\//.test(path)) return true;
    if (SKIP_PAGE_RE.test(path)) return true;
    var handle = productHandle();
    if (handle && SKIP_PAGE_RE.test(handle)) return true;
    var classes = ((document.documentElement && document.documentElement.className) || '') +
      ' ' +
      ((document.body && document.body.className) || '');
    return SKIP_PAGE_RE.test(classes);
  }

  function findButtons() {
    return (
      document.querySelector('form.main-product-form .product-form__buttons') ||
      document.querySelector('.product__block--buy_buttons .product-form__buttons') ||
      document.querySelector('.main-product-form .product-form__buttons')
    );
  }

  function findQtyInput(buttons) {
    if (!buttons) return null;
    var form = buttons.closest('form') || document.querySelector('form.main-product-form');
    var scope = form || buttons;
    return (
      scope.querySelector('.product-form__quantity input[name="quantity"]') ||
      scope.querySelector('input.quantity__input[name="quantity"]') ||
      scope.querySelector('input[name="quantity"]')
    );
  }

  function findMultiAdd() {
    return (
      document.querySelector('city-product-dropdown-multi-add') ||
      document.querySelector('.city-product-dropdown--multi-add')
    );
  }

  function cleanText(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .replace(/[•|]+/g, ' ')
      .trim();
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/\u003c/g, '&lt;');
  }

  function escapeAttr(value) {
    return String(value || '').replace(/"/g, '&quot;');
  }

  function handleFromHref(href) {
    if (!href) return '';
    try {
      var path = href.indexOf('http') === 0 ? new URL(href, location.origin).pathname : String(href);
      var match = path.toLowerCase().match(/\/products\/([^/?#]+)/);
      return match && match[1] ? decodeURIComponent(match[1]) : '';
    } catch (e) {
      return '';
    }
  }

  function currentVariantId() {
    var form = document.querySelector('form.main-product-form');
    var input = form && form.querySelector('input[name="id"], select[name="id"]');
    if (input && input.value) return String(input.value);
    try {
      var meta = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product;
      var selected = meta && meta.selectedVariantId;
      if (selected) return String(selected);
    } catch (e) {}
    return '';
  }

  function shortTitle(value) {
    return cleanText(value)
      .replace(/Adventure Bucket List/gi, '')
      .replace(/Bucket List/gi, '')
      .replace(/Explorers/gi, '')
      .trim();
  }

  function currentTitle(currentRow) {
    var fromRow = currentRow && currentRow.querySelector('.city-product-dropdown__item-title');
    if (fromRow && shortTitle(fromRow.textContent)) return shortTitle(fromRow.textContent);
    var heading = document.querySelector('[id^="ProductInfo-"] .product__title, .product__title, h1');
    if (heading && shortTitle(heading.textContent)) return shortTitle(heading.textContent);
    return 'This bucket list';
  }

  function largerImage(src) {
    if (!src) return '';
    return String(src)
      .replace(/_\d+x(\d+)?/g, '_400x')
      .replace(/width=\d+/gi, 'width=400');
  }

  function imageFromEl(el) {
    if (!el) return '';
    var srcset = el.getAttribute('srcset') || '';
    if (srcset) {
      var last = srcset.split(',').pop();
      var url = last && last.trim().split(/\s+/)[0];
      if (url) return largerImage(url);
    }
    return largerImage(el.getAttribute('src') || '');
  }

  function currentImage(currentRow) {
    var thumb = currentRow && currentRow.querySelector('.city-product-dropdown__thumb, img');
    var fromThumb = imageFromEl(thumb);
    if (fromThumb) return fromThumb;
    var hero = document.querySelector('.product__media img, .product-media img, [id^="MediaGallery"] img');
    return imageFromEl(hero);
  }

  function offerCopy() {
    var bar = document.querySelector('.announcement-bar__text');
    if (bar) {
      var barText = cleanText(bar.textContent);
      if (barText) return barText;
    }

    var bundle = document.querySelector('.announcement-bar-bundle');
    if (bundle) {
      var bits = [];
      var eyebrow = bundle.querySelector('.announcement-bar-bundle__eyebrow');
      if (eyebrow) bits.push(cleanText(eyebrow.textContent));
      var tiers = bundle.querySelectorAll('.announcement-bar-bundle__tier');
      for (var i = 0; i < tiers.length; i++) {
        bits.push(cleanText(tiers[i].textContent));
      }
      var joined = cleanText(bits.filter(Boolean).join(' '));
      if (joined) return joined;
    }

    return '';
  }

  function offerBadge() {
    var raw = offerCopy();
    var bogo = raw && raw.match(/bogo\s*(\d+)\s*%/i);
    if (bogo) return 'BOGO ' + bogo[1] + '%';
    // Kit extras and add-on cards are the 2-unit tier. Fall Sale is
    // 20% off 2 / 25% off 3+. Do not prefix BOGO onto a volume %.
    if (!raw || /\b20\s*%/.test(raw) || /\b25\s*%/.test(raw) || /fall sale|%\s*off/i.test(raw)) {
      return '20% off';
    }
    var pct = raw.match(/(\d+)\s*%/);
    if (pct) return pct[1] + '% off';
    return raw.length > 18 ? raw.slice(0, 16) : raw;
  }

  function scrapeRowPrice(row) {
    var sale = row && (
      row.querySelector('.city-product-dropdown__item-price--discounted') ||
      row.querySelector('.city-product-dropdown__item-price')
    );
    var compare = row && row.querySelector('.city-product-dropdown__item-price--compare');
    return {
      price: cleanText(sale && sale.textContent),
      compare: cleanText(compare && compare.textContent)
    };
  }

  function scrapeCatalog() {
    var root = findMultiAdd();
    var items = [];
    var seen = {};

    function add(item) {
      if (!item || !item.handle || seen[item.handle]) return;
      if (SKIP_ITEM_RE.test(item.handle) || SKIP_ITEM_RE.test(item.title || '')) return;
      seen[item.handle] = true;
      items.push(item);
    }

    var currentRow = root && root.querySelector('.city-product-dropdown__item--current');
    add({
      handle: productHandle(),
      url: location.pathname,
      title: currentTitle(currentRow),
      variantId: currentVariantId(),
      image: currentImage(currentRow),
      price: '',
      compare: '',
      priceCents: 0,
      complementary: false,
      current: true
    });

    if (!root) return items;

    var rows = root.querySelectorAll('.city-product-dropdown__item--multi-add');
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      if (row.classList.contains('city-product-dropdown__item--current')) continue;
      var link = row.querySelector('a[href*="/products/"]');
      var toggle = row.querySelector('[data-city-product-multi-add-toggle]');
      var href = link ? (link.getAttribute('href') || link.href) : '';
      var handle = handleFromHref(href);
      var titleEl = row.querySelector('.city-product-dropdown__item-title');
      var img = row.querySelector('.city-product-dropdown__thumb, img');
      var pricing = scrapeRowPrice(row);
      add({
        handle: handle,
        url: href,
        title: shortTitle(titleEl && titleEl.textContent) || handle,
        variantId: toggle ? String(toggle.getAttribute('data-variant-id') || '') : '',
        image: imageFromEl(img),
        price: pricing.price,
        compare: pricing.compare,
        priceCents: toggle ? parseInt(toggle.getAttribute('data-variant-price-cents'), 10) || 0 : 0,
        complementary: row.classList.contains('city-product-dropdown__item--complementary'),
        current: false
      });
    }

    return items;
  }

  function isAddonHandle(handle) {
    return ADDON_HANDLES.indexOf(String(handle || '').toLowerCase()) !== -1;
  }

  function formatMoney(cents) {
    var value = Number(cents);
    if (!value && value !== 0) return '';
    return '$' + (value / 100).toFixed(2);
  }

  function parseCents(value) {
    if (value == null || value === '') return 0;
    if (typeof value === 'number' && isFinite(value)) return Math.round(value);
    var raw = String(value);
    var n = parseFloat(raw.replace(/[^0-9.]/g, ''));
    if (!isFinite(n) || n <= 0) return 0;
    if (raw.indexOf('.') !== -1 || n < 400) return Math.round(n * 100);
    return Math.round(n);
  }

  function listCents(variantId, fallbackCents) {
    var fallback = parseInt(fallbackCents, 10) || 0;
    if (window.RioIgPrice && typeof window.RioIgPrice.getListPriceCents === 'function') {
      return window.RioIgPrice.getListPriceCents(variantId, fallback) || fallback;
    }
    return fallback;
  }

  function currentFallbackCents() {
    var qty = document.querySelector('.quantity_selector');
    if (qty && qty.dataset.price) {
      var fromQty = parseInt(qty.dataset.price, 10) || parseCents(qty.dataset.price);
      if (fromQty > 0) return fromQty;
    }
    var cached = addonCache[productHandle()];
    if (cached && cached.priceCents) return cached.priceCents;
    return 0;
  }

  function extraFallbackCents(variantId) {
    if (!variantId) return 0;
    var btn = document.querySelector(
      '[data-city-product-multi-add-toggle][data-variant-id="' + variantId + '"]'
    );
    if (btn) {
      var fromBtn = parseInt(btn.getAttribute('data-variant-price-cents'), 10) || 0;
      if (fromBtn > 0) return fromBtn;
    }
    var cached = addonCache[productHandle()];
    if (cached && String(cached.variantId) === String(variantId) && cached.priceCents) {
      return cached.priceCents;
    }
    var keys = Object.keys(addonCache);
    for (var i = 0; i < keys.length; i++) {
      var item = addonCache[keys[i]];
      if (item && String(item.variantId) === String(variantId) && item.priceCents) return item.priceCents;
    }
    return 0;
  }

  function selectedUnitPrices(root) {
    var units = [];
    var currentVid = currentVariantId();
    var currentCents = listCents(currentVid, currentFallbackCents());
    if (currentCents > 0) units.push(currentCents);
    var ids = selectedKitIds(root).concat(checkedAddonIds(root));
    for (var i = 0; i < ids.length; i++) {
      if (!ids[i] || String(ids[i]) === String(currentVid)) continue;
      var cents = listCents(ids[i], extraFallbackCents(ids[i]));
      if (cents > 0) units.push(cents);
    }
    return units;
  }

  function promoTotalCents(units) {
    if (window.RioIgPrice && typeof window.RioIgPrice.computePromoTotalCents === 'function') {
      return window.RioIgPrice.computePromoTotalCents(units, false);
    }
    var list = (units || []).filter(function (cents) { return cents > 0; });
    if (!list.length) return 0;
    var pct = list.length >= 3 ? 25 : list.length >= 2 ? 20 : 0;
    if (pct <= 0) {
      return list.reduce(function (sum, cents) { return sum + cents; }, 0);
    }
    return list.reduce(function (sum, cents) {
      return sum + (cents - Math.round((cents * pct) / 100));
    }, 0);
  }

  function formatAtcMoney(cents) {
    if (window.RioIgPrice && typeof window.RioIgPrice.formatMoney === 'function') {
      return window.RioIgPrice.formatMoney(cents);
    }
    return formatMoney(cents);
  }

  function findAtcLabel(buttons) {
    var scope = buttons || findButtons() || document;
    return scope.querySelector('[id^="AddToCartText-"]') || document.querySelector('[id^="AddToCartText-"]');
  }

  function updateAtcPrice(root, buttons) {
    var label = findAtcLabel(buttons || (root && root.parentNode));
    if (!label) return;
    var raw = cleanText(label.textContent);
    if (/sold out/i.test(raw)) return;
    var cents = promoTotalCents(selectedUnitPrices(root));
    if (!cents) return;
    if (!label.getAttribute('data-rio-atc-base')) {
      var stripped = raw.replace(/\s*[-–—]\s*\$[\d.,]+.*$/i, '').trim();
      label.setAttribute('data-rio-atc-base', stripped || 'Add to cart');
    }
    var next = label.getAttribute('data-rio-atc-base') + ' - ' + formatAtcMoney(cents);
    if (label.textContent !== next) label.textContent = next;
    window.__rioStickyAtcSuffix = ' - ' + formatAtcMoney(cents);
    try {
      document.dispatchEvent(new CustomEvent('rio:atc-total-changed', {
        detail: { suffix: window.__rioStickyAtcSuffix, totalCents: cents }
      }));
    } catch (e) {}
  }

  function productId() {
    try {
      var meta = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product;
      if (meta && meta.id) return String(meta.id);
    } catch (e) {}
    return '';
  }

  function itemFromProductJson(product) {
    if (!product || !product.handle) return null;
    var variant = (product.variants && product.variants[0]) || {};
    var image = product.featured_image || (product.images && product.images[0]) || '';
    if (image && typeof image === 'object') image = image.src || '';
    return {
      handle: product.handle,
      url: '/products/' + product.handle,
      title: shortTitle(product.title) || product.handle,
      variantId: variant.id ? String(variant.id) : '',
      image: largerImage(image),
      price: formatMoney(variant.price),
      compare: formatMoney(variant.compare_at_price),
      priceCents: Number(variant.price) || 0,
      complementary: false,
      current: false
    };
  }

  function catalogByHandle(catalog) {
    var map = {};
    for (var i = 0; i < (catalog || []).length; i++) {
      if (catalog[i].handle) map[catalog[i].handle.toLowerCase()] = catalog[i];
    }
    return map;
  }

  function complementaryItems(catalog) {
    var list = [];
    var current = productHandle();
    for (var i = 0; i < (catalog || []).length && list.length < MAX_ADDON_EXTRAS; i++) {
      var item = catalog[i];
      if (!item || !item.complementary || item.current) continue;
      if (item.handle && item.handle === current) continue;
      list.push(item);
    }
    if (list.length) return list;
    var recs = recCache[current + ':comp'] || [];
    for (var j = 0; j < recs.length && list.length < MAX_ADDON_EXTRAS; j++) {
      if (!recs[j] || recs[j].handle === current) continue;
      list.push(recs[j]);
    }
    return list;
  }

  function kitCompanions(catalog) {
    var list = [];
    for (var i = 0; i < catalog.length; i++) {
      if (!catalog[i].complementary) continue;
      if (isAddonHandle(catalog[i].handle)) continue;
      list.push(catalog[i]);
      if (list.length >= MAX_KIT_EXTRAS) break;
    }
    var recs = recCache[productHandle()] || [];
    for (var j = 0; j < recs.length && list.length < MAX_KIT_EXTRAS; j++) {
      var rec = recs[j];
      if (!rec || !rec.handle || rec.handle === productHandle()) continue;
      if (isAddonHandle(rec.handle)) continue;
      var already = false;
      for (var k = 0; k < list.length; k++) {
        if (list[k].handle === rec.handle) already = true;
      }
      if (!already) list.push(rec);
    }
    return list;
  }

  function resolveAddons(catalog) {
    if (MODE === 'addons') return complementaryItems(catalog);
    var map = catalogByHandle(catalog);
    var current = productHandle();
    var list = [];
    for (var i = 0; i < ADDON_HANDLES.length; i++) {
      var handle = ADDON_HANDLES[i];
      if (handle === current) continue;
      var item = map[handle] || addonCache[handle];
      if (item) list.push(item);
    }
    return list;
  }

  function requestProduct(handle) {
    if (!handle || addonCache[handle] || addonCache[handle + ':pending']) return;
    addonCache[handle + ':pending'] = true;
    fetch('/products/' + handle + '.js')
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (product) {
        var item = itemFromProductJson(product);
        if (item) addonCache[handle] = item;
        apply();
      })
      .catch(function () {});
  }

  function requestRecommendations(current) {
    var handle = current && current.handle;
    var id = productId();
    if (!handle || !id || recCache[handle] || recCache[handle + ':pending']) return;
    recCache[handle + ':pending'] = true;
    fetch('/recommendations/products.json?product_id=' + encodeURIComponent(id) + '&limit=10')
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        var products = (data && data.products) || [];
        recCache[handle] = products.map(itemFromProductJson).filter(Boolean);
        apply();
      })
      .catch(function () {});
  }

  function requestComplementary(current) {
    var handle = current && current.handle;
    var id = productId();
    var key = handle + ':comp';
    if (!handle || !id || recCache[key] || recCache[key + ':pending']) return;
    recCache[key + ':pending'] = true;
    fetch('/recommendations/products.json?product_id=' + encodeURIComponent(id) + '&limit=10&intent=complementary')
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        var products = (data && data.products) || [];
        recCache[key] = products.map(itemFromProductJson).filter(Boolean);
        apply();
      })
      .catch(function () {});
  }

  function setQuantity(input, qty) {
    if (!input) return;
    var next = String(qty);
    if (input.value !== next) input.value = next;
    try {
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    } catch (e) {}
  }

  function setCompanions(variantIds) {
    var root = findMultiAdd();
    if (!root) return;
    var wanted = {};
    for (var i = 0; i < (variantIds || []).length; i++) {
      if (variantIds[i]) wanted[String(variantIds[i])] = true;
    }
    var buttons = root.querySelectorAll('[data-city-product-multi-add-toggle]');
    if (root.toggleButtons) root.toggleButtons = Array.prototype.slice.call(buttons);
    for (var j = 0; j < buttons.length; j++) {
      var on = !!wanted[String(buttons[j].getAttribute('data-variant-id') || '')];
      if (typeof root.setToggleState === 'function') {
        root.setToggleState(buttons[j], on);
      } else {
        buttons[j].setAttribute('aria-pressed', on ? 'true' : 'false');
        buttons[j].classList.toggle('is-selected', on);
      }
    }
    try {
      document.dispatchEvent(new CustomEvent('city-product-multi-add:selection-changed', {
        detail: { formId: root.getAttribute('data-product-form-id') || '' }
      }));
    } catch (e) {}
  }

  function keepPreviewParams(href) {
    try {
      var next = new URL(href, location.origin);
      var current = new URLSearchParams(location.search);
      ['ig-preview', 'igTg', 'pb'].forEach(function (key) {
        var value = current.get(key);
        if (value) next.searchParams.set(key, value);
      });
      return next.pathname + next.search + next.hash;
    } catch (e) {
      return href;
    }
  }

  function kitPlans(current, comps) {
    var plans = [{
      key: 'solo',
      title: current.title || 'This bucket list',
      image: current.image,
      ids: [],
      badge: false
    }];
    for (var i = 0; i < comps.length && i < MAX_KIT_EXTRAS; i++) {
      if (!comps[i] || !comps[i].variantId) continue;
      plans.push({
        key: 'plus-' + i,
        title: '+' + comps[i].title,
        image: comps[i].image || current.image,
        ids: [comps[i].variantId],
        badge: true
      });
    }
    return plans;
  }

  function ensureHiddenToggle(variantId, title, priceCents) {
    if (!variantId) return;
    var root = findMultiAdd();
    if (!root) return;
    var existing = root.querySelector('[data-city-product-multi-add-toggle][data-variant-id="' + variantId + '"]');
    if (existing) {
      if (priceCents && !existing.getAttribute('data-variant-price-cents')) {
        existing.setAttribute('data-variant-price-cents', String(priceCents));
      }
      return;
    }
    var button = document.createElement('button');
    button.type = 'button';
    button.hidden = true;
    button.setAttribute('data-city-product-multi-add-toggle', '');
    button.setAttribute('data-variant-id', String(variantId));
    if (priceCents) button.setAttribute('data-variant-price-cents', String(priceCents));
    button.setAttribute('aria-pressed', 'false');
    button.setAttribute('aria-label', 'Add ' + (title || 'product') + ' to cart selection');
    root.appendChild(button);
  }

  function selectedKitIds(root) {
    var on = root && root.querySelector('.rio-pdp-swatch.is-selected');
    var raw = on && on.getAttribute('data-kit-ids');
    if (!raw) return [];
    return raw.split(',').filter(Boolean);
  }

  function selectedKitTitle(root) {
    var on = root && root.querySelector('.rio-pdp-swatch.is-selected');
    return (on && on.getAttribute('data-kit-title')) || '';
  }

  function checkedAddonIds(root) {
    var boxes = root ? root.querySelectorAll('.rio-pdp-addon__check:checked') : [];
    var ids = [];
    for (var i = 0; i < boxes.length; i++) {
      var id = boxes[i].getAttribute('data-variant-id');
      if (id) ids.push(id);
    }
    return ids;
  }

  function syncCart(root, input) {
    setQuantity(input || findQtyInput(root && root.parentNode), 1);
    var ids = selectedKitIds(root).concat(checkedAddonIds(root));
    setCompanions(ids);
    updateAtcPrice(root, root && root.parentNode);
    requestAnimationFrame(function () { updateAtcPrice(root); });
    setTimeout(function () { updateAtcPrice(root); }, 0);
  }

  function selectKit(root, key) {
    var swatches = root.querySelectorAll('.rio-pdp-swatch');
    for (var i = 0; i < swatches.length; i++) {
      var on = swatches[i].getAttribute('data-kit-key') === key;
      swatches[i].classList.toggle('is-selected', on);
      swatches[i].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
    var label = root.querySelector('[data-rio-kit-selected]');
    if (label) label.textContent = selectedKitTitle(root);
  }

  function addonCandidates(addons, kitIds) {
    var blocked = {};
    for (var i = 0; i < kitIds.length; i++) blocked[String(kitIds[i])] = true;
    var list = [];
    for (var j = 0; j < addons.length; j++) {
      if (!addons[j].variantId || blocked[String(addons[j].variantId)]) continue;
      if (addons[j].handle && addons[j].handle === productHandle()) continue;
      list.push(addons[j]);
    }
    return list;
  }

  function renderAddons(root, addons) {
    var list = root.querySelector('[data-rio-addon-list]');
    var wrap = root.querySelector('.rio-pdp-addons');
    if (!list || !wrap) return;
    if (MODE === 'kit') {
      wrap.hidden = true;
      list.innerHTML = '';
      return;
    }

    var keep = {};
    var checked = root.querySelectorAll('.rio-pdp-addon__check:checked');
    for (var i = 0; i < checked.length; i++) {
      keep[String(checked[i].getAttribute('data-variant-id') || '')] = true;
    }

    var items = addonCandidates(addons, selectedKitIds(root));
    var badge = offerBadge();
    wrap.hidden = items.length === 0;
    var html = '';
    for (var j = 0; j < items.length; j++) {
      var item = items[j];
      var on = !!keep[String(item.variantId)];
      var compare = item.compare && item.compare !== item.price
        ? '<s>' + escapeHtml(item.compare) + '</s>'
        : '';
      html +=
        '<li class="rio-pdp-addon' + (on ? ' is-checked' : '') + '" data-variant-id="' + escapeAttr(item.variantId) + '">' +
        '<input class="rio-pdp-addon__check" type="checkbox" data-variant-id="' + escapeAttr(item.variantId) + '"' +
        (on ? ' checked' : '') + ' aria-label="Add ' + escapeAttr(item.title) + '">' +
        '<span class="rio-pdp-addon__image">' +
        (item.image ? '<img src="' + escapeAttr(item.image) + '" alt="">' : '') +
        '</span>' +
        '<span class="rio-pdp-addon__copy">' +
        '<span class="rio-pdp-addon__title">' + escapeHtml(item.title) + '</span>' +
        '<span class="rio-pdp-addon__meta">' +
        (item.price ? '<span class="rio-pdp-addon__price">' + compare + escapeHtml(item.price) + '</span>' : '') +
        (badge ? '<span class="rio-pdp-badge">' + escapeHtml(badge) + '</span>' : '') +
        '</span>' +
        (item.url
          ? '<a class="rio-pdp-addon__more" href="' + escapeAttr(keepPreviewParams(item.url)) + '">Learn more</a>'
          : '') +
        '</span></li>';
    }
    if (list.getAttribute('data-rio-addon-sig') === html) return;
    list.setAttribute('data-rio-addon-sig', html);
    list.innerHTML = html;
  }

  function buildBox(current, comps, addons) {
    var root = document.createElement('div');
    root.id = ROOT_ID;
    root.setAttribute('data-mode', MODE);

    var badge = offerBadge();
    var plans = kitPlans(current, comps);
    var showKits = MODE !== 'addons' && plans.length;
    var showAddons = MODE !== 'kit' && addons.length;

    if (showKits) {
      var kits = document.createElement('div');
      kits.className = 'rio-pdp-kits';
      var kitHtml =
        '<p class="rio-pdp-label">Make it a bundle: <span class="rio-pdp-label__selected" data-rio-kit-selected>' +
        escapeHtml(plans[0].title) +
        '</span></p><div class="rio-pdp-swatches" role="list">';
      for (var i = 0; i < plans.length; i++) {
        var plan = plans[i];
        kitHtml +=
          '<button type="button" class="rio-pdp-swatch' + (i === 0 ? ' is-selected' : '') +
          '" role="listitem" data-kit-key="' + escapeAttr(plan.key) +
          '" data-kit-title="' + escapeAttr(plan.title) +
          '" data-kit-ids="' + escapeAttr(plan.ids.join(',')) +
          '" aria-pressed="' + (i === 0 ? 'true' : 'false') + '">' +
          '<span class="rio-pdp-swatch__image">' +
          (plan.badge && badge ? '<span class="rio-pdp-badge">' + escapeHtml(badge) + '</span>' : '') +
          (plan.image ? '<img src="' + escapeAttr(plan.image) + '" alt="">' : '') +
          '</span>' +
          '<span class="rio-pdp-swatch__title">' + escapeHtml(plan.title) + '</span>' +
          '</button>';
      }
      kitHtml += '</div>';
      kits.innerHTML = kitHtml;
      root.appendChild(kits);
    }

    if (showAddons || MODE === 'addons') {
      var addons = document.createElement('div');
      addons.className = 'rio-pdp-addons';
      addons.innerHTML =
        '<p class="rio-pdp-label">Adventure add-ons</p>' +
        '<ul class="rio-pdp-addons__list" data-rio-addon-list></ul>';
      root.appendChild(addons);
    }

    return root;
  }

  function bind(root, input, addons) {
    if (root.getAttribute('data-rio-bound') === '1') return;
    root.setAttribute('data-rio-bound', '1');

    root.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var more = target.closest('.rio-pdp-addon__more');
      if (more) return;

      var swatch = target.closest('.rio-pdp-swatch');
      if (swatch && root.contains(swatch)) {
        event.preventDefault();
        selectKit(root, swatch.getAttribute('data-kit-key'));
        renderAddons(root, addons);
        syncCart(root, input || findQtyInput(root.parentNode));
        return;
      }

      if (target.closest('.rio-pdp-addon__check')) {
        event.stopPropagation();
        return;
      }

      var addon = target.closest('.rio-pdp-addon');
      if (addon && root.contains(addon)) {
        event.preventDefault();
        var box = addon.querySelector('.rio-pdp-addon__check');
        if (box) box.checked = !box.checked;
        addon.classList.toggle('is-checked', !!box && box.checked);
        syncCart(root, input || findQtyInput(root.parentNode));
      }
    });

    root.addEventListener('change', function (event) {
      var target = event.target;
      if (!target || !target.classList.contains('rio-pdp-addon__check')) return;
      var row = target.closest('.rio-pdp-addon');
      if (row) row.classList.toggle('is-checked', target.checked);
      syncCart(root, input || findQtyInput(root.parentNode));
    });
  }

  function apply() {
    if (shouldSkip()) return false;

    var catalog = scrapeCatalog();
    var current = catalog[0] || { handle: productHandle(), title: currentTitle(null), image: currentImage(null) };
    var comps = kitCompanions(catalog);
    var addons = resolveAddons(catalog);

    if (MODE === 'addons') {
      if (!addons.length) requestComplementary(current);
    } else {
      if (comps.length < MAX_KIT_EXTRAS) requestRecommendations(current);
      for (var a = 0; a < ADDON_HANDLES.length; a++) {
        if (ADDON_HANDLES[a] === current.handle) continue;
        if (!catalogByHandle(catalog)[ADDON_HANDLES[a]] && !addonCache[ADDON_HANDLES[a]]) {
          requestProduct(ADDON_HANDLES[a]);
        }
      }
    }

    if (MODE === 'addons' && !addons.length) return false;
    if (MODE === 'kit' && !comps.length && !current.handle) return false;

    document.documentElement.classList.add(READY);

    var buttons = findButtons();
    if (!buttons) return false;

    if (current.handle && !addonCache[current.handle] && !addonCache[current.handle + ':pending']) {
      requestProduct(current.handle);
    }

    for (var t = 0; t < addons.length; t++) {
      ensureHiddenToggle(addons[t].variantId, addons[t].title, addons[t].priceCents);
    }
    for (var c = 0; c < comps.length; c++) {
      ensureHiddenToggle(comps[c].variantId, comps[c].title, comps[c].priceCents);
    }

    buttons.classList.add(ACTIVE);
    var input = findQtyInput(buttons);
    var existing = document.getElementById(ROOT_ID);
    var signature = MODE + ':' + (current.handle || '') + ':' +
      comps.map(function (item) { return item.variantId; }).join(',') + ':' +
      addons.map(function (item) { return item.variantId; }).join(',');

    if (existing && existing.getAttribute('data-rio-sig') === signature) {
      bind(existing, input, addons);
      renderAddons(existing, addons);
      syncCart(existing, input);
      return true;
    }

    if (existing) existing.parentNode.removeChild(existing);

    var root = buildBox(current, comps, addons);
    root.setAttribute('data-rio-sig', signature);
    buttons.insertBefore(root, buttons.firstChild);
    renderAddons(root, addons);
    bind(root, input, addons);
    syncCart(root, input);
    return true;
  }

  function boot() {
    if (shouldSkip()) return;

    document.addEventListener('city-product-multi-add:selection-changed', function () {
      var root = document.getElementById(ROOT_ID);
      if (root) updateAtcPrice(root);
    });
    document.addEventListener('rio:ig-price-ready', function () {
      var root = document.getElementById(ROOT_ID);
      if (root) updateAtcPrice(root);
    });
    if (window.RioIgPrice && typeof window.RioIgPrice.whenReady === 'function') {
      window.RioIgPrice.whenReady().then(function () {
        var root = document.getElementById(ROOT_ID);
        if (root) updateAtcPrice(root);
      });
    }

    apply();

    var tries = 0;
    var retry = setInterval(function () {
      tries += 1;
      apply();
      if (tries >= 16) clearInterval(retry);
    }, 250);

    var host = document.querySelector('[id^="ProductInfo-"]') ||
      document.querySelector('.product__info-container') ||
      document.body;
    var timer = null;
    var observer = new MutationObserver(function () {
      if (timer) clearTimeout(timer);
      timer = setTimeout(apply, 80);
    });
    if (host) observer.observe(host, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
